class LeadLostReason {
    static Price() {
        return 1;
    }

    static Timing() {
        return 2;
    }

    static Competitor() {
        return 3;
    }

    static NoFit() {
        return 4;
    }

    static NoResponse() {
        return 5;
    }

    static Other() {
        return 6;
    }
}

export default LeadLostReason;
